<section class="chart-wrapper">
  <h3 class="text-white">{{ searchForm.value.title }}</h3>
  <div class="chart-box">
    <canvas id="myChart"></canvas>
  </div>
</section>
